import { render, staticRenderFns } from "./PhotoLabel.vue?vue&type=template&id=5ec46e65&"
import script from "./PhotoLabel.vue?vue&type=script&lang=js&"
export * from "./PhotoLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports